import gql from 'graphql-tag'

export default gql`
query{
  studentUsers(limit: 10000){
    _id
    username
    firstname
    lastname
    avatar
    email
    description
    mobile
  }
}
`
